// Load polyfills if needed

const modernBrowser = ( 'fetch' in window && 'assign' in Object );
if( !modernBrowser ) {
	const scriptElement = document.createElement('script');
	scriptElement.async = false;
	scriptElement.src = '../../assets/js/polyfills.bundle.js';
	document.head.appendChild(scriptElement);
	console.info('loaded polyfills');
}

require('es6-promise').polyfill();

import $ from 'jquery';
import _ from 'lodash';

window.$ = window.jQuery = $;
window._ = _;

import 'bootstrap';
import 'svgxuse';
import 'slick-carousel';
import 'bootstrap-select/dist/js/bootstrap-select.min.js';
import inlineSVG from 'inline-svg';

inlineSVG.init({
	svgSelector: 'img.svg',
	initClass: 'js-inlinesvg'
});

import 'bootstrap-slider/dist/bootstrap-slider.min.js';
